import { fetchWrapper } from "_helpers";
import { toast, Slide } from "react-toastify";

export const exportJobList = async ({
  sortField = "",
  sortOrder = "",
  searchQuery = "",
  filters = {},
  id = [],
}) => {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
  try {
    let apiUrl = baseUrl + `/admin/getInterfaceList?isExporting=true`;
    apiUrl += sortField?.length ? `&sort=${sortField}&order=${sortOrder}` : "";
    apiUrl += searchQuery.length ? `&search=${searchQuery}` : "";
    apiUrl += filters?.createDate?.from
      ? `&startDate=${filters?.createDate?.from}`
      : "";
    apiUrl += filters?.createDate?.to
      ? `&endDate=${filters?.createDate?.to}`
      : "";
    apiUrl += filters?.jobName?.length
      ? filters.jobName.map((id) => `&jobName[]=${id}`).join("")
      : "";
    apiUrl += id?.length ? id.map((id) => `&ids[]=${id}`).join("") : "";
    const response = await fetchWrapper.get(apiUrl);
    const blob = await response.blob();
    const baseName = "Job_List";
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0]; // YYYY-MM-DD format
    const formattedTime = now.toTimeString().split(" ")[0].replace(/:/g, "_"); // HH_MM_SS format
    const urlXls = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = urlXls;
    a.download = `${baseName}_${formattedDate} ${formattedTime}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    await window.URL.revokeObjectURL(urlXls);
    toast(<div>Downloaded Sucessfully!</div>, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
    });
    return response;
  } catch (error) {
    console.error("err  ", error);
    toast.error(<div>❗ {error}</div>, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
    });
    return { error };
  }
};

// apiUrl += isExporting ? `&isExporting=${isExporting}` : "";
export const getInterfaceList = async ({
  page,
  pageSize = 20,
  sortField,
  sortOrder,
  searchQuery,
  filters,
}) => {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
  try {
    let apiUrl = `${baseUrl}/admin/getInterfaceList?page=${page}&size=${pageSize}`;
    apiUrl += sortField.length ? `&sort=${sortField}&order=${sortOrder}` : "";
    apiUrl += searchQuery.length ? `&search=${searchQuery}` : "";
    apiUrl += filters?.createDate?.from
      ? `&startDate=${filters?.createDate?.from}`
      : "";
    apiUrl += filters?.createDate?.to
      ? `&endDate=${filters?.createDate?.to}`
      : "";
    apiUrl += filters?.jobName?.length
      ? filters.jobName.map((id) => `&jobName[]=${id}`).join("")
      : "";
    return await fetchWrapper.get(apiUrl);
  } catch (error) {
    toast.error(
      <div>
        ❗ Something went wrong!
        <br /> Please try again later.
      </div>,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      }
    );
    return { data: { totalItems: 0, rows: [] }, error };
  }
};

export const getJobList = async () => {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
  try {
    let apiUrl = `${baseUrl}/admin/getJobList`;
    return await fetchWrapper.get(apiUrl);
  } catch (error) {
    toast.error(
      <div>
        ❗ Something went wrong!
        <br /> Please try again later.
      </div>,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      }
    );
    return { data: [], error };
  }
};
